var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-carousel-container"},[_c('p',[_vm._v("My focus is on ")]),_c('b',[_c('div',{staticClass:"text-carousel-list colored-text"},[_vm._v(" usability."),_c('br'),_vm._v(" accessibility."),_c('br'),_vm._v(" clean designs."),_c('br'),_vm._v(" rich UX."),_c('br'),_vm._v(" pixel perfection. ")])])])
}]

export { render, staticRenderFns }